import {
  provideTanStackQuery,
  QueryClient,
  withDevtools,
} from '@tanstack/angular-query-experimental';

export const provideTanstack = () =>
  provideTanStackQuery(
    new QueryClient({
      defaultOptions: {
        queries: {
          gcTime: 0,
          staleTime: Infinity,
        },
      },
    }),
    withDevtools(() => ({ buttonPosition: 'bottom-right' }))
  );
